// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- PoiTable.css --- */

/* Contenitore Generale */
.poi-container {
  padding: 1.5rem;
  background-color: #f8fafc; /* slate-50 */
  min-height: 100vh;
  font-family: ui-sans-serif, system-ui, sans-serif;
  color: #334155; /* slate-700 */
}

.poi-wrapper {
  max-width: 80rem; /* max-w-7xl */
  margin: 0 auto;
}

/* Header */
.poi-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.poi-header-icon {
  width: 2rem;
  height: 2rem;
  color: #2563eb; /* blue-600 */
}

.poi-title {
  font-size: 1.5rem; /* text-2xl */
  font-weight: 700;
  color: #1e293b; /* slate-800 */
  margin: 0;
}

.poi-subtitle {
  color: #64748b; /* slate-500 */
  font-size: 0.875rem; /* text-sm */
  margin: 0;
}

/* Card Tabella */
.poi-card {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0; /* slate-200 */
  overflow: hidden;
}

.poi-table-responsive {
  overflow-x: auto;
}

/* Tabella */
.poi-table {
  width: 100%;
  text-align: left;
  font-size: 0.875rem; /* text-sm */
  border-collapse: collapse;
}

.poi-table thead {
  background-color: #f1f5f9; /* slate-100 */
  text-transform: uppercase;
  font-weight: 600;
  color: #334155;
}

.poi-table th,
.poi-table td {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.poi-table tr:hover {
  background-color: #f8fafc; /* hover:bg-slate-50 */
}

/* Celle Specifiche */
.poi-id {
  font-family: monospace;
  color: #94a3b8; /* slate-400 */
  font-size: 0.75rem;
}

.poi-name {
  font-weight: 700;
  font-size: 1rem;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.poi-desc {
  font-size: 0.75rem;
  color: #64748b;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.poi-address {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
  color: #334155;
}

.poi-coords {
  padding-left: 1.5rem;
  font-size: 0.75rem;
  font-family: monospace;
  color: #94a3b8;
}

/* Liste (Layers e BIM) */
.poi-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.poi-tag {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  width: fit-content;
}

/* Colori Tag */
.tag-blue {
  background-color: #eff6ff; /* blue-50 */
  color: #1d4ed8; /* blue-700 */
  border: 1px solid #dbeafe;
}

.tag-purple {
  background-color: #faf5ff; /* purple-50 */
  color: #7e22ce; /* purple-700 */
  border: 1px solid #f3e8ff;
  flex-direction: column;
  align-items: flex-start;
}

.tag-link {
  color: inherit;
  text-decoration: none;
}
.tag-link:hover {
  text-decoration: underline;
}

/* Pulsante Link Esterno */
.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  background-color: #f1f5f9;
  color: #475569;
  text-decoration: none;
  transition: background-color 0.2s;
}

.btn-icon:hover {
  background-color: #dbeafe;
  color: #2563eb;
}

/* Footer Tabella */
.poi-footer {
  background-color: #f8fafc;
  padding: 0.75rem 1.5rem;
  border-top: 1px solid #e2e8f0;
  font-size: 0.75rem;
  color: #64748b;
  display: flex;
  justify-content: space-between;
}

/* Stati Loading/Error */
.poi-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 16rem;
  color: #64748b;
}

.poi-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16rem;
  margin: 1rem;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  color: #ef4444;
  border-radius: 0.5rem;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/poitable.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,yBAAyB;AACzB;EACE,eAAe;EACf,yBAAyB,EAAE,aAAa;EACxC,iBAAiB;EACjB,iDAAiD;EACjD,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,gBAAgB,EAAE,cAAc;EAChC,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,iBAAiB,EAAE,aAAa;EAChC,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc,EAAE,cAAc;EAC9B,mBAAmB,EAAE,YAAY;EACjC,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,qBAAqB;EACrB,2CAA2C;EAC3C,yBAAyB,EAAE,cAAc;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB,EAAE,YAAY;EACjC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA,qBAAqB;AACrB;EACE,sBAAsB;EACtB,cAAc,EAAE,cAAc;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,yBAAyB,EAAE,YAAY;EACvC,cAAc,EAAE,aAAa;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,cAAc,EAAE,eAAe;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,WAAW;AACb","sourcesContent":["/* --- PoiTable.css --- */\r\n\r\n/* Contenitore Generale */\r\n.poi-container {\r\n  padding: 1.5rem;\r\n  background-color: #f8fafc; /* slate-50 */\r\n  min-height: 100vh;\r\n  font-family: ui-sans-serif, system-ui, sans-serif;\r\n  color: #334155; /* slate-700 */\r\n}\r\n\r\n.poi-wrapper {\r\n  max-width: 80rem; /* max-w-7xl */\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Header */\r\n.poi-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.poi-header-icon {\r\n  width: 2rem;\r\n  height: 2rem;\r\n  color: #2563eb; /* blue-600 */\r\n}\r\n\r\n.poi-title {\r\n  font-size: 1.5rem; /* text-2xl */\r\n  font-weight: 700;\r\n  color: #1e293b; /* slate-800 */\r\n  margin: 0;\r\n}\r\n\r\n.poi-subtitle {\r\n  color: #64748b; /* slate-500 */\r\n  font-size: 0.875rem; /* text-sm */\r\n  margin: 0;\r\n}\r\n\r\n/* Card Tabella */\r\n.poi-card {\r\n  background-color: white;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\r\n  border: 1px solid #e2e8f0; /* slate-200 */\r\n  overflow: hidden;\r\n}\r\n\r\n.poi-table-responsive {\r\n  overflow-x: auto;\r\n}\r\n\r\n/* Tabella */\r\n.poi-table {\r\n  width: 100%;\r\n  text-align: left;\r\n  font-size: 0.875rem; /* text-sm */\r\n  border-collapse: collapse;\r\n}\r\n\r\n.poi-table thead {\r\n  background-color: #f1f5f9; /* slate-100 */\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n  color: #334155;\r\n}\r\n\r\n.poi-table th,\r\n.poi-table td {\r\n  padding: 1rem 1.5rem;\r\n  border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.poi-table tr:hover {\r\n  background-color: #f8fafc; /* hover:bg-slate-50 */\r\n}\r\n\r\n/* Celle Specifiche */\r\n.poi-id {\r\n  font-family: monospace;\r\n  color: #94a3b8; /* slate-400 */\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.poi-name {\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n  color: #1e293b;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.poi-desc {\r\n  font-size: 0.75rem;\r\n  color: #64748b;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n}\r\n\r\n.poi-address {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n  margin-bottom: 0.25rem;\r\n  color: #334155;\r\n}\r\n\r\n.poi-coords {\r\n  padding-left: 1.5rem;\r\n  font-size: 0.75rem;\r\n  font-family: monospace;\r\n  color: #94a3b8;\r\n}\r\n\r\n/* Liste (Layers e BIM) */\r\n.poi-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.poi-tag {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-size: 0.75rem;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 0.25rem;\r\n  width: fit-content;\r\n}\r\n\r\n/* Colori Tag */\r\n.tag-blue {\r\n  background-color: #eff6ff; /* blue-50 */\r\n  color: #1d4ed8; /* blue-700 */\r\n  border: 1px solid #dbeafe;\r\n}\r\n\r\n.tag-purple {\r\n  background-color: #faf5ff; /* purple-50 */\r\n  color: #7e22ce; /* purple-700 */\r\n  border: 1px solid #f3e8ff;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n}\r\n\r\n.tag-link {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n.tag-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Pulsante Link Esterno */\r\n.btn-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  border-radius: 9999px;\r\n  background-color: #f1f5f9;\r\n  color: #475569;\r\n  text-decoration: none;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.btn-icon:hover {\r\n  background-color: #dbeafe;\r\n  color: #2563eb;\r\n}\r\n\r\n/* Footer Tabella */\r\n.poi-footer {\r\n  background-color: #f8fafc;\r\n  padding: 0.75rem 1.5rem;\r\n  border-top: 1px solid #e2e8f0;\r\n  font-size: 0.75rem;\r\n  color: #64748b;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n/* Stati Loading/Error */\r\n.poi-message {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 16rem;\r\n  color: #64748b;\r\n}\r\n\r\n.poi-error {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 16rem;\r\n  margin: 1rem;\r\n  background-color: #fef2f2;\r\n  border: 1px solid #fecaca;\r\n  color: #ef4444;\r\n  border-radius: 0.5rem;\r\n  gap: 0.5rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
